const alertsMiddleware = store => next => (action) => {
    if (action.type === 'AGE_CONFIRMATION_TOGGLE') {
        store.dispatch({ type: 'TOGGLE' });
        if (!action.ageConfirmationToggle) {
            store.dispatch({ type: 'TOGGLE_LEOVEGAS_LOGO_OFF' });
        }
    }
    next(action);
};

export default alertsMiddleware;
